export default "__VITE_ASSET__B$b0ABe___"